import {
  BACKOFFICE_LOGIN_RECEIVED,
  BACKOFFICE_LOGIN_SET_IS_LOADING,
  BACKOFFICE_LOGIN_SET_REDIRECT_URL,
  BACKOFFICE_LOGIN_SET_USERNAME_PASSWORD,
} from '../constants';
import {
  backofficeLogin,
  BackofficeLoginState,
} from '../Reducers/BackofficeLogin.reducer';
import { post } from '../Services/http';

export const handleSubmitLogin = (
  username?: string,
  password?: string
) => (dispatch) => {
  dispatch(setIsLoading(true));

  post(`/litium/authenticate`, {
    username: username,
    password: password,
  })
    .then((res) => res.json())
    .then((response) => dispatch(setReceived(response)))
    .then(() => dispatch(handleRedirect()))
    .catch((err) => console.log(err))
    .finally(() => dispatch(setIsLoading(false)));
};

export const handleSubmitCode = (
  e: React.FormEvent<HTMLFormElement>,
  username?: string,
  code?: string,
  loginToken?: string
) => (dispatch) => {
  e.preventDefault();
  dispatch(setIsLoading(true));

  post(`/litium/login`, {
    username: username,
    password: '',
    code: code,
    loginToken
  })
    .then((res) => res.json())
    .then((response) => dispatch(setReceived(response)))
    .then(() => dispatch(handleRedirect()))
    .catch((err) => console.log(err))
    .finally(() => dispatch(setIsLoading(false)));
};

export const setReceived = (backofficeLogin: BackofficeLoginState) => {
  return {
    type: BACKOFFICE_LOGIN_RECEIVED,
    payload: {
      backofficeLogin,
    },
  };
};

export const setUsername = (username: string) => {
  return {
    type: BACKOFFICE_LOGIN_SET_USERNAME_PASSWORD,
    payload: {
      username,
    },
  };
};

export const setRedirectUrl = (redirectUrl: string) => {
  return {
    type: BACKOFFICE_LOGIN_SET_REDIRECT_URL,
    payload: {
      redirectUrl,
    },
  };
};

const setIsLoading = (isLoading: boolean) => {
  return {
    type: BACKOFFICE_LOGIN_SET_IS_LOADING,
    payload: {
      isLoading,
    },
  };
};

export const handleRedirect = () => (dispatch, getState) => {
  const backofficeLoginState = getState().backofficeLogin;
  if (backofficeLoginState.success) {
    window.location.href = backofficeLoginState.redirectUrl;
  }
};
